
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import { Options, Vue } from 'vue-class-component';
import { _ROUTER_NAME } from '@/enums';

@Options({
	name: 'GroupReport',
	components: {
		DaIcon,
	},
	computed: {
		_ROUTER_NAME() {
			return _ROUTER_NAME;
		},
	},
})
export default class GroupReport extends Vue {
	openFilter = 0;

	tabs: any = [
		{
			id: 0,
			name: 'Báo cáo buổi học',
			icon: 'das--book',
			link: _ROUTER_NAME.REPORT_GROUP,
		},
		{
			id: 1,
			name: 'Báo cáo tuần',
			icon: 'das--calender',
			link: _ROUTER_NAME.REPORT_WEEK_GROUP,
		},
		{
			id: 2,
			name: 'Báo cáo tháng',
			icon: 'das--statics',
			link: _ROUTER_NAME.REPORT_PLANS_GROUP,
		},
	];

	triggerFilter() {
		this.openFilter = Date.now();
	}
}
